import * as React from 'react';
import {
  DecodedValueMap,
  QueryParamConfigMap,
  StringParam,
  useCustomSearchParams,
  withDefault,
} from 'common/hooks/customSearchParams';
import { OutstandingFeesBreakdown } from 'services/clients/insights';
import { GlobalStorageKeys, LocalStorageUtil } from 'utils/local-storage.util';

export const useDashboardParams = (resetPageParamOnUpdate?: boolean) => {
  // Create param map with default values
  const paramMap: QueryParamConfigMap = React.useMemo(() => {
    const defaultDemurrageBreakdown =
      LocalStorageUtil.get(GlobalStorageKeys.ShippersDashboardDemurrageBreakdown) ||
      OutstandingFeesBreakdown.Terminal;

    const defaultPerDiemBreakdown =
      LocalStorageUtil.get(GlobalStorageKeys.ShippersDashboardPerDiemBreakdown) ||
      OutstandingFeesBreakdown.Port;

    return {
      demurrageBreakdown: withDefault(StringParam, defaultDemurrageBreakdown),
      perDiemBreakdown: withDefault(StringParam, defaultPerDiemBreakdown),
    };
  }, []);

  const { searchParams, setSearchParams } = useCustomSearchParams(paramMap, resetPageParamOnUpdate);

  const decoratedSetSearchParams = React.useCallback(
    (
      params: Partial<DecodedValueMap<QueryParamConfigMap>>,
      keepOtherParams?: boolean | undefined
    ) => {
      if (params.demurrageBreakdown) {
        LocalStorageUtil.set(
          GlobalStorageKeys.ShippersDashboardDemurrageBreakdown,
          params.demurrageBreakdown
        );
      }
      if (params.perDiemBreakdown) {
        LocalStorageUtil.set(
          GlobalStorageKeys.ShippersDashboardPerDiemBreakdown,
          params.perDiemBreakdown
        );
      }

      setSearchParams(params, keepOtherParams);
    },
    [setSearchParams]
  );

  return { searchParams, setSearchParams: decoratedSetSearchParams };
};

export const SHIPMENTS_DASHBOARD_QUERY_PARAMS: QueryParamConfigMap = {
  demurrageBreakdown: withDefault(StringParam, OutstandingFeesBreakdown.ShippingLine),
  perDiemBreakdown: withDefault(StringParam, OutstandingFeesBreakdown.ShippingLine),
};
